import { ContentBlock } from "../../types/contentBlock";
import { TextListBlock } from "../../types/textListBlock";
import { linkQuery } from "./link";

export const textListBlockQuery = `
    _type == 'textListBlock' => 
        _type,
        link {
            ${linkQuery}
        },
        text,
        title,
        listType,
        services[] -> {
            title,
            serviceCategories
        },
        listItems[] {
            title,
            listItems
        }
`


export const isTextListBlock = (textBlock: ContentBlock): textBlock is TextListBlock => {
    return textBlock._type === 'textListBlock';
}

